import * as _ from "lodash";
import * as angular from "angular";
import { CustomFieldService } from "../../../services/custom-field.service";
import { DialogUtils } from "../../../helper/dialog.helper";

let CanvassCustomFieldComponent = {
    selector: "vcCanvassCustomField",
    templateUrl:
        "/angular/components/canvass/modals/canvass-custom-field.component.html",
    bindings: {
        selectedField: "=",
    },
    controller: class CanvassCustomFieldController {
        // * bindings for typescript compiler *
        public selectedField: any;
        // ************************************

        private customfield: any;

        private dialog: DialogUtils;
        private customFieldService: CustomFieldService;

        constructor(
            DialogUtils: DialogUtils,
            CustomFieldService: CustomFieldService
        ) {
            this.dialog = DialogUtils;

            this.customFieldService = CustomFieldService;
        }

        $onInit() {
            this.customfield = _.cloneDeep(this.selectedField);
        }

        confirm(): void {
            if (this.customfield.searchText) {
                this.customfield.hocfvalue = _.cloneDeep(
                    this.customfield.searchText
                );
            }
            this.dialog.hide(this.customfield);
        }

        cancel(): void {
            this.dialog.cancel();
        }

        setSelectedOption(options: any[], selectedOption: any): void {
            angular.forEach(options, (option) => {
                option.selected = 0;
            });
            selectedOption.selected = 1;
            this.confirm();
        }

        searchCustomFieldValues(
            id: number | string,
            searchString: string
        ): Promise<any> {
            return this.customFieldService
                .searchValues({ id: id, search: searchString })
                .then((response: object) => {
                    return response["data"].data;
                });
        }

        //custom field find the selected option
        selectedOption(options: any[]): object | null {
            let selectedOptions = options.filter(
                (option) => option.selected == 1
            );
            if (selectedOptions.length > 0) return selectedOptions[0];
            return null;
        }
    },
};

angular
    .module("canvass")
    .component(
        CanvassCustomFieldComponent.selector,
        CanvassCustomFieldComponent
    );
